import { MigrationControllerApi, UploadFileCategoryEnum } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";
type MutationParam = {
  type?: UploadFileCategoryEnum;
  title: string;
  file: File;
  providerGroupUuid?: string;
  xTENANTID?: string;
};

/**
 *
 * @author rajkumar rathod
 */
export const useUploadCsv = () =>
  useMutationWithLoading(async (params: MutationParam) =>
    new MigrationControllerApi(getConfigObject()).uploadFile(
      params.type ?? "PATIENT",
      params.title,
      params.file,
      params?.providerGroupUuid,
      params?.xTENANTID
    )
  );
